export default "__VITE_ASSET__Ci1tARdQ__"